export default __webpack_public_path__ + "scripts/resources/assignments/es/default/configuration.json";